module.exports = __webpack_public_path__ + "img/Forklane-logo.39b11546.webp";